// removed by extract-text-webpack-plugin
module.exports = {"footerContent":"_3UyICb9ECy4PYnh4F4xcf-","legal":"_1I6sKaAWQOnGLH11uNHhJ3","security":"_2zBa2-Q53eOoAISZlFH3VR","copyright":"_3BvgGiPwdwPrDDBNS3ibQx","portalFooter":"_3jRdEtr6t6bkHtBcA3h4Wm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/style.scss
// module id = 874
// module chunks = 1